const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            cancel:             'Cancelar',
            component:          'Forfait',
            component_new:      'Novo forfait',
            component_edit:     'Editar forfait',
            component_list:     'Lista de forfaits',
            close:              'Fechar',
            color:              'Cor',
            color_placeholder:  'Introduza a cor',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:     'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:      'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_pessoas:      'Pessoas',
            field_pessoas_placeholder: 'Introduza o número de pessoas',
            field_tipo:      'Tipo',
            field_tipo_placeholder: 'Introduza o tipo',
            field_tipologia:      'Tipologia',
            field_tipologia_placeholder: 'Introduza o tipologia',
            field_dias:          'Dias',
            field_dias_placeholder: 'Introduza o número de dias',
            field_description:   'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_price_s_vat:  'Preço do Forfait (s/ IVA)',
            field_forfait_price_s_vat_placeholder: 'Introduza o preço do Forfait (s/ IVA)',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_pista_price:  'Preço do aluguer da pista',
            field_pista_price_placeholder: 'Introduza o preço do aluguer da pista',
            field_pista_taxe:  'IVA do aluguer da pista',
            field_pista_taxe_placeholder: 'Introduza o IVA do aluguer da pista',
            field_pista_price_s_vat:  'Preço do aluguer da pista (s/ IVA)',
            field_pista_price_s_vat_placeholder: 'Introduza o preço do aluguer da pista (s/ IVA)',
            field_price:        'Preço',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_canhoes:      'Canhões de neve',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            field_equipamentos: 'Tem equipamentos?',
            field_visivel:      'Visível?',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            principal:          'Principal',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            save:               'Salvar',                  
        },
    'en':
        {
            add_new:            'Add new',
            calendar:           'Calendar',
            cancel:             'Cancel',
            component:          'Frofait',
            component_new:      'New forfait',
            component_edit:     'Edit forfait',
            component_list:     'List of forfaits',
            close:              'Close',
            color:              'Color',
            color_placeholder:  'Insert the color',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:     'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:      'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_pessoas:      'Pessoas',
            field_pessoas_placeholder: 'Introduza o número de pessoas',
            field_tipo:      'Tipo',
            field_tipo_placeholder: 'Introduza o tipo',
            field_tipologia:      'Tipologia',
            field_tipologia_placeholder: 'Introduza o tipologia',
            field_dias:          'Dias',
            field_dias_placeholder: 'Introduza o número de dias',
            field_description:   'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_pista_price:  'Preço do aluguer da pista',
            field_pista_price_placeholder: 'Introduza o preço do aluguer da pista',
            field_pista_taxe:  'IVA do aluguer da pista',
            field_pista_taxe_placeholder: 'Introduza o IVA do aluguer da pista',
            field_pista_price_s_vat:  'Preço do aluguer da pista (s/ IVA)',
            field_pista_price_s_vat_placeholder: 'Introduza o preço do aluguer da pista (s/ IVA)',
            field_price:        'Preço',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_canhoes:      'Canhões de neve',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            field_equipamentos: 'Tem equipamentos?',
            field_visivel:      'Visível?',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            principal:          'Principal',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            save:               'Save',
        }
}

module.exports = {
    language
};